import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=b4dd3334"
import script from "./SelectProduct.vue?vue&type=script&lang=js"
export * from "./SelectProduct.vue?vue&type=script&lang=js"
import style0 from "./SelectProduct.vue?vue&type=style&index=0&id=b4dd3334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports